// extracted by mini-css-extract-plugin
export default {"h4":"H4title_h4__mSMIF","white":"H4title_white__D+OyK"};